import './ValidationRuleMetadataTab.scss';

import { CodeHighlight } from '@ui/general';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PERISCOPE_VALIDATION_RULE_COPY } from '@sonar-software/sonar-ts-constants';

import { DetailSection, DetailSubsection } from '@periscopes/general';
import { PeriscopeValidationRuleMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { usePeriscopeActions, usePeriscopeMetadata } from '@hooks';

export interface ValidationRuleMetadataTabProps {
	displayName: string;
	index: number;
	sonarObjectId: number;
}

export const ValidationRuleMetadataTab: React.FC<ValidationRuleMetadataTabProps> = ({
	displayName,
	index,
	sonarObjectId
}) => {
	const { openPeriscope } = usePeriscopeActions();
	const { loading, metadata } = usePeriscopeMetadata<PeriscopeValidationRuleMetadata>(
		sonarObjectId,
		SonarObjectType.SalesforceValidationRule
	);

	const childName = `.${displayName}`;

	const handleEntityClick = useCallback(() => {
		if (!metadata) {
			return;
		}

		openPeriscope({
			id: metadata.parentSonarObjectId,
			name: metadata.parentDisplayName,
			openLeft: true,
			openedFromIndex: index,
			type: SonarObjectType.SalesforceEntity
		});
	}, [ index, metadata, openPeriscope ]);

	if (!metadata || loading) {
		return <LoadingSpinner spinning />;
	}

	return (
		<DetailSection className='validation-rule-metadata'>
			<DetailSubsection title={ PERISCOPE_VALIDATION_RULE_COPY.CODE_SNIPPET }>
				<CodeHighlight
					code={ metadata.code }
					codeReferences={ metadata.codeReferences }
					index={ index } />
			</DetailSubsection>
			<DetailSubsection
				className='parent-object'
				title={ PERISCOPE_VALIDATION_RULE_COPY.PARENT_OBJECT }>
				<span
					className='reference-link'
					onClick={ handleEntityClick }>
					<b>{ metadata.parentDisplayName }</b>
					{ childName }
				</span>
			</DetailSubsection>
		</DetailSection>
	);
};
